<template>
  <div class="license-plate">
    <div class="plate flex" :style="plateStyle" v-if="licenseNo"  @dblclick="$utils.dblclickCopy">
      <div>{{ licenseNo.slice(0, 2) }}</div>
      <span class="dot" :style="dotStyle"></span>
      <div>{{ licenseNo.slice(2) }}</div>
    </div>
    <div class="license-plate" v-else>-</div>
  </div>
  
</template>

<script>
export default {
    props: {
        licenseNo: {
            type: String,
            default: ''
        },
        licenseColor: {
            type: String,
            default: ''
        },
        vehicleSeat: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            license: [
                {   
                    key: 'blur',
                    label: '蓝色',
                    bg: require('@/assets/img/licensePlate/blue.png'),
                    textColor: '#ffffff'
                },
                {
                    key: 'yellow',
                    label: '黄色',
                    bg: require('@/assets/img/licensePlate/yellow.png'),
                    textColor: '#000000'
                },
                {
                    key: 'black',
                    label: '黑色',
                    bg: require('@/assets/img/licensePlate/black.png'),
                    textColor: '#ffffff'
                },
                {
                    key: 'white',
                    label: '白色',
                    bg: require('@/assets/img/licensePlate/white.png'),
                    textColor: '#000000'
                },
                {
                    key: 'green',
                    label: '绿色',
                    bg: require('@/assets/img/licensePlate/green.png'),
                    textColor: '#000000'
                },
                {
                    key: 'yellowAndGreen',
                    label: '黄绿色',
                    bg: require('@/assets/img/licensePlate/yellowAndGreen.png'),
                    textColor: '#000000'
                }
            ]
        }
    },
    computed: {
        currentPlate() {
            // 特殊处理绿色车牌且座位数大于等于19的情况
            if (this.licenseColor === '绿色' && this.vehicleSeat >= 19) {
                return this.license.find(item => item.key === 'yellowAndGreen');
            }
            return this.license.find(item => item.label === this.licenseColor) || this.license[0];
        },
        plateStyle() {
            return {
                backgroundImage: `url(${this.currentPlate.bg})`,
                color: this.currentPlate.textColor
            }
        },
        dotStyle() {
            return {
                background: this.currentPlate.textColor
            }
        }
    }
}
</script>

<style scoped>
.license-plate {
    display: inline-block;
}
.dot {
    display: block;
    width: 2px;
    height: 2px;
    margin: 0 4px;
}
.plate {
    width: 108px;
    height: 30px;
    justify-content: center;
    font-size: 14px;
    font-weight: bold;
    background-size: 100% 100%;
    background-repeat: no-repeat;
}
.plate div {
    height: 30px;
    line-height: 30px;
}
</style>